import { Box, DialogContent, DialogTitle } from "@mui/material";
import { usersBusiness } from "api/bussiness/user-role-permission/users-bussiness";
import { AddUser as AddUserModel } from "api/models/request/user-role/users";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { useCallback, useEffect } from "react";
import { string } from "yup";
import { DynamicForm } from "../../../../commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "../../../../commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "../../../../commons/ultilities/dynamic-form/models/control";
import { useStores } from "../../../../mobx-stores/_root-store";
import { DialogForm } from "../../../../share-components/templates/form/dialog-form";

export const AddUser = observer(() => {
  const {
    userManagement: { openNew, setProp, getUsers, pagination },
    catalogueStore: { getRoles, rolesAsOptionItems },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
  } = useForm<AddUserModel>(
    {
      userName: {
        gridSize: 6,
        label: "Tài khoản",
        type: InputType.text,
        validattionYupSchema: string().trim().required().max(256),
      },
      name: {
        gridSize: 6,
        label: "Tên người dùng",
        type: InputType.text,
        validattionYupSchema: string().trim().required().max(64),
      },
      password: {
        gridSize: 12,
        label: "Mật khẩu",
        type: InputType.password,
        validattionYupSchema: string().required().max(128),
      },
      email: {
        gridSize: 7,
        label: "Email",
        type: InputType.text,
        validattionYupSchema: string().email().required().max(256),
      },
      phoneNumber: {
        gridSize: 5,
        label: "Số điện thoại",
        type: InputType.text,
        validattionYupSchema: string().max(16),
      },
      roleNames: {
        gridSize: 12,
        label: "Vai trò",
        optionItems: [
          {
            label: "Role 1",
            value: "R1",
          },
          {
            label: "Role 2",
            value: "R2",
          },
        ],
        type: InputType.autoCompleteMultiple,
      },
      isActive: {
        gridSize: 12,
        label: "Hoạt động",
        type: InputType.checkbox,
      },
    },
    {
      name: "",
      password: "",
      userName: "",
      email: "",
      phoneNumber: "",
      isActive: true,
      roleNames: [],
    }
  );

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  useEffect(() => {
    if (rolesAsOptionItems) {
      getControl("roleNames").setProp(
        "optionItems",
        cloneDeep(rolesAsOptionItems)
      );
    }
  }, [getControl, rolesAsOptionItems]);

  const saveHandler = useCallback(
    async (data: AddUserModel) => {
      await usersBusiness.addUser(data);
      await getUsers({
        filter: pagination.filter,
        maxResultCount: pagination.itemsPerPage,
        skipCount: pagination.skipCount,
      });
      setProp("openNew", false);
    },
    [
      getUsers,
      pagination.filter,
      pagination.itemsPerPage,
      pagination.skipCount,
      setProp,
    ]
  );
  return (
    <DialogForm
      open={openNew}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm mới tài khoản</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
